// Audio Tools (vocal remover, key & BPM finder, pitch & tempo changer).
const en = {
  "nav.audioTools": "Vocal Remover & Audio Tools",
  "at.title": "Audio Tools",
  "at.subtitle": "AI vocal remover, key & BPM finder and pitch changer — right inside EAM.",
  "at.badgeAi": "AI",
  "at.tab.separate": "Vocal Remover",
  "at.tab.analyze": "Key & BPM",
  "at.tab.pitch": "Pitch & Tempo",

  "at.drop.title": "Drop your song here",
  "at.drop.or": "or",
  "at.drop.browse": "Browse files",
  "at.drop.hint": "MP3, WAV, FLAC, M4A, OGG… up to {mb} MB, {min} minutes",
  "at.drop.change": "Change file",
  "at.drop.invalid": "Unsupported file type",
  "at.drop.tooLarge": "File is larger than {mb} MB",

  "at.sep.heroTitle": "Separate vocals from any song",
  "at.sep.heroDesc": "Our AI model splits a track into a clean vocal and an instrumental (karaoke) stem. Great for remixes, acapellas, practice and sample-ready stems.",
  "at.sep.hq": "High quality mode",
  "at.sep.hqDesc": "Two-pass inference with less artefacts — takes about twice as long.",
  "at.sep.start": "Remove vocals",
  "at.sep.vocals": "Vocals",
  "at.sep.instrumental": "Instrumental",
  "at.sep.mixer": "Stem mixer",
  "at.sep.mixerHint": "Play both stems in sync and balance them with the faders.",
  "at.sep.newFile": "Process another song",

  "at.stage.queued": "Waiting in queue",
  "at.stage.starting": "Starting",
  "at.stage.loading_model": "Loading AI model",
  "at.stage.decoding": "Reading audio",
  "at.stage.separating": "Separating vocals",
  "at.stage.processing": "Processing",
  "at.stage.encoding": "Encoding files",
  "at.stage.analyzing": "Detecting key & BPM",
  "at.stage.done": "Done",
  "at.stage.uploading": "Uploading",
  "at.queuePos": "{n} job(s) ahead of you",
  "at.keepOpen": "You can leave this page — the job keeps running and appears in your history.",

  "at.player.play": "Play",
  "at.player.pause": "Pause",
  "at.player.mute": "Mute",
  "at.player.unmute": "Unmute",
  "at.player.solo": "Solo",
  "at.player.loading": "Loading audio…",
  "at.player.error": "Audio could not be loaded",

  "at.download": "Download",
  "at.downloadMp3": "MP3 (320 kbps)",
  "at.downloadWav": "WAV (lossless)",

  "at.history": "Recent jobs",
  "at.historyEmpty": "Your processed songs will appear here.",
  "at.historyExpires": "Files are kept for {days} days.",
  "at.open": "Open",
  "at.delete": "Delete",
  "at.deleted": "Deleted",
  "at.status.queued": "Queued",
  "at.status.processing": "Processing",
  "at.status.done": "Ready",
  "at.status.failed": "Failed",

  "at.usage": "{used}/{limit} jobs today",
  "at.usageUnlimited": "Unlimited",

  "at.err.unsupported_format": "This file format isn't supported.",
  "at.err.file_too_large": "The file is too large.",
  "at.err.empty_file": "The file is empty.",
  "at.err.daily_limit_reached": "You've reached today's limit. Upgrade your plan for more.",
  "at.err.too_long": "The song is longer than the allowed duration.",
  "at.err.processing_failed": "Processing failed. Please try another file.",
  "at.err.interrupted": "The job was interrupted. Please try again.",
  "at.err.no_change": "Change the pitch or tempo first.",
  "at.err.invalid_params": "Invalid settings.",
  "at.err.analysis_failed": "We couldn't analyze this file.",
  "at.err.generic": "Something went wrong. Please try again.",
  "at.retry": "Try again",

  "at.an.heroTitle": "Find the key and BPM of any song",
  "at.an.heroDesc": "Detect tempo, musical key and Camelot code — perfect for DJ mixing, remixing and pitching to playlists.",
  "at.an.start": "Analyze",
  "at.an.analyzing": "Analyzing…",
  "at.an.bpm": "Tempo",
  "at.an.key": "Key",
  "at.an.camelot": "Camelot",
  "at.an.confidence": "Confidence",
  "at.an.halfDouble": "Half / double time: {half} · {double}",
  "at.an.alternatives": "Other possible keys",
  "at.an.major": "major",
  "at.an.minor": "minor",
  "at.an.tapTempo": "Tap tempo",
  "at.an.tapHint": "Tap along to the beat to double-check the BPM.",
  "at.an.tap": "Tap",
  "at.an.reset": "Reset",

  "at.pt.heroTitle": "Change pitch and tempo",
  "at.pt.heroDesc": "Shift the key by up to 12 semitones or speed the song up / slow it down without changing pitch. Studio-grade Rubber Band engine.",
  "at.pt.semitones": "Pitch (semitones)",
  "at.pt.tempo": "Tempo",
  "at.pt.formant": "Preserve formants (natural vocals)",
  "at.pt.formantDesc": "Keeps voices from sounding chipmunk-like when shifting.",
  "at.pt.preview": "Live preview",
  "at.pt.previewHint": "Instant browser preview (pitch & tempo linked). Render for the high-quality result.",
  "at.pt.start": "Render",
  "at.pt.result": "Result",
  "at.pt.reset": "Reset",
  "at.pt.st": "st",
};

const tr = {
  "nav.audioTools": "Vokal Ayırıcı & Ses Araçları",
  "at.title": "Ses Araçları",
  "at.subtitle": "Yapay zekâ vokal ayırıcı, ton & BPM bulucu ve pitch değiştirici — EAM içinde.",
  "at.badgeAi": "AI",
  "at.tab.separate": "Vokal Ayırıcı",
  "at.tab.analyze": "Ton & BPM",
  "at.tab.pitch": "Pitch & Tempo",

  "at.drop.title": "Şarkını buraya bırak",
  "at.drop.or": "veya",
  "at.drop.browse": "Dosya seç",
  "at.drop.hint": "MP3, WAV, FLAC, M4A, OGG… en fazla {mb} MB, {min} dakika",
  "at.drop.change": "Dosyayı değiştir",
  "at.drop.invalid": "Desteklenmeyen dosya türü",
  "at.drop.tooLarge": "Dosya {mb} MB'tan büyük",

  "at.sep.heroTitle": "Herhangi bir şarkıdan vokali ayır",
  "at.sep.heroDesc": "Yapay zekâ modelimiz parçayı temiz bir vokal ve enstrümantal (karaoke) olarak ikiye ayırır. Remix, akapella, prova ve sample için ideal.",
  "at.sep.hq": "Yüksek kalite modu",
  "at.sep.hqDesc": "Daha az artefakt için iki geçişli işlem — yaklaşık iki kat sürer.",
  "at.sep.start": "Vokali ayır",
  "at.sep.vocals": "Vokal",
  "at.sep.instrumental": "Enstrümantal",
  "at.sep.mixer": "Kanal mikseri",
  "at.sep.mixerHint": "İki kanalı senkron çal, fader'larla dengele.",
  "at.sep.newFile": "Başka bir şarkı işle",

  "at.stage.queued": "Sırada bekliyor",
  "at.stage.starting": "Başlatılıyor",
  "at.stage.loading_model": "AI modeli yükleniyor",
  "at.stage.decoding": "Ses okunuyor",
  "at.stage.separating": "Vokal ayrıştırılıyor",
  "at.stage.processing": "İşleniyor",
  "at.stage.encoding": "Dosyalar hazırlanıyor",
  "at.stage.analyzing": "Ton & BPM tespit ediliyor",
  "at.stage.done": "Tamamlandı",
  "at.stage.uploading": "Yükleniyor",
  "at.queuePos": "Önünde {n} iş var",
  "at.keepOpen": "Sayfadan ayrılabilirsin — işlem devam eder ve geçmişinde görünür.",

  "at.player.play": "Oynat",
  "at.player.pause": "Duraklat",
  "at.player.mute": "Sessize al",
  "at.player.unmute": "Sesi aç",
  "at.player.solo": "Solo",
  "at.player.loading": "Ses yükleniyor…",
  "at.player.error": "Ses yüklenemedi",

  "at.download": "İndir",
  "at.downloadMp3": "MP3 (320 kbps)",
  "at.downloadWav": "WAV (kayıpsız)",

  "at.history": "Son işlemler",
  "at.historyEmpty": "İşlediğin şarkılar burada görünecek.",
  "at.historyExpires": "Dosyalar {days} gün saklanır.",
  "at.open": "Aç",
  "at.delete": "Sil",
  "at.deleted": "Silindi",
  "at.status.queued": "Sırada",
  "at.status.processing": "İşleniyor",
  "at.status.done": "Hazır",
  "at.status.failed": "Başarısız",

  "at.usage": "Bugün {used}/{limit} işlem",
  "at.usageUnlimited": "Sınırsız",

  "at.err.unsupported_format": "Bu dosya formatı desteklenmiyor.",
  "at.err.file_too_large": "Dosya çok büyük.",
  "at.err.empty_file": "Dosya boş.",
  "at.err.daily_limit_reached": "Günlük limitine ulaştın. Daha fazlası için planını yükselt.",
  "at.err.too_long": "Şarkı izin verilen süreden uzun.",
  "at.err.processing_failed": "İşlem başarısız oldu. Lütfen başka bir dosya dene.",
  "at.err.interrupted": "İşlem yarıda kaldı. Lütfen tekrar dene.",
  "at.err.no_change": "Önce pitch veya tempoyu değiştir.",
  "at.err.invalid_params": "Geçersiz ayarlar.",
  "at.err.analysis_failed": "Bu dosya analiz edilemedi.",
  "at.err.generic": "Bir şeyler ters gitti. Lütfen tekrar dene.",
  "at.retry": "Tekrar dene",

  "at.an.heroTitle": "Her şarkının tonunu ve BPM'ini bul",
  "at.an.heroDesc": "Tempo, müzikal ton ve Camelot kodunu tespit et — DJ geçişleri, remix ve playlist pitch'leri için ideal.",
  "at.an.start": "Analiz et",
  "at.an.analyzing": "Analiz ediliyor…",
  "at.an.bpm": "Tempo",
  "at.an.key": "Ton",
  "at.an.camelot": "Camelot",
  "at.an.confidence": "Güven",
  "at.an.halfDouble": "Yarım / çift tempo: {half} · {double}",
  "at.an.alternatives": "Diğer olası tonlar",
  "at.an.major": "majör",
  "at.an.minor": "minör",
  "at.an.tapTempo": "Tap tempo",
  "at.an.tapHint": "BPM'i doğrulamak için ritme göre dokun.",
  "at.an.tap": "Dokun",
  "at.an.reset": "Sıfırla",

  "at.pt.heroTitle": "Pitch ve tempoyu değiştir",
  "at.pt.heroDesc": "Tonu 12 yarım tona kadar kaydır ya da tonu bozmadan şarkıyı hızlandır / yavaşlat. Stüdyo kalitesinde Rubber Band motoru.",
  "at.pt.semitones": "Pitch (yarım ton)",
  "at.pt.tempo": "Tempo",
  "at.pt.formant": "Formantları koru (doğal vokal)",
  "at.pt.formantDesc": "Ton kaydırırken seslerin \"sincap\" gibi duyulmasını engeller.",
  "at.pt.preview": "Canlı önizleme",
  "at.pt.previewHint": "Tarayıcıda anlık önizleme (pitch ve tempo birlikte değişir). Yüksek kaliteli sonuç için oluştur.",
  "at.pt.start": "Oluştur",
  "at.pt.result": "Sonuç",
  "at.pt.reset": "Sıfırla",
  "at.pt.st": "yt",
};

const es = {
  "nav.audioTools": "Separador de voz y herramientas",
  "at.title": "Herramientas de audio",
  "at.subtitle": "Separador de voz con IA, detector de tono y BPM y cambio de tono — dentro de EAM.",
  "at.badgeAi": "IA",
  "at.tab.separate": "Separador de voz",
  "at.tab.analyze": "Tono y BPM",
  "at.tab.pitch": "Tono y tempo",

  "at.drop.title": "Suelta tu canción aquí",
  "at.drop.or": "o",
  "at.drop.browse": "Elegir archivo",
  "at.drop.hint": "MP3, WAV, FLAC, M4A, OGG… hasta {mb} MB, {min} minutos",
  "at.drop.change": "Cambiar archivo",
  "at.drop.invalid": "Tipo de archivo no compatible",
  "at.drop.tooLarge": "El archivo supera {mb} MB",

  "at.sep.heroTitle": "Separa la voz de cualquier canción",
  "at.sep.heroDesc": "Nuestro modelo de IA divide la pista en una voz limpia y una instrumental (karaoke). Ideal para remixes, acapellas, práctica y samples.",
  "at.sep.hq": "Modo alta calidad",
  "at.sep.hqDesc": "Inferencia en dos pasadas con menos artefactos — tarda el doble.",
  "at.sep.start": "Quitar voz",
  "at.sep.vocals": "Voz",
  "at.sep.instrumental": "Instrumental",
  "at.sep.mixer": "Mezclador de pistas",
  "at.sep.mixerHint": "Reproduce ambas pistas sincronizadas y equilíbralas con los faders.",
  "at.sep.newFile": "Procesar otra canción",

  "at.stage.queued": "En cola",
  "at.stage.starting": "Iniciando",
  "at.stage.loading_model": "Cargando modelo de IA",
  "at.stage.decoding": "Leyendo audio",
  "at.stage.separating": "Separando voz",
  "at.stage.processing": "Procesando",
  "at.stage.encoding": "Codificando archivos",
  "at.stage.analyzing": "Detectando tono y BPM",
  "at.stage.done": "Listo",
  "at.stage.uploading": "Subiendo",
  "at.queuePos": "{n} trabajo(s) delante de ti",
  "at.keepOpen": "Puedes salir de esta página — el trabajo sigue y aparecerá en tu historial.",

  "at.player.play": "Reproducir",
  "at.player.pause": "Pausar",
  "at.player.mute": "Silenciar",
  "at.player.unmute": "Activar sonido",
  "at.player.solo": "Solo",
  "at.player.loading": "Cargando audio…",
  "at.player.error": "No se pudo cargar el audio",

  "at.download": "Descargar",
  "at.downloadMp3": "MP3 (320 kbps)",
  "at.downloadWav": "WAV (sin pérdida)",

  "at.history": "Trabajos recientes",
  "at.historyEmpty": "Tus canciones procesadas aparecerán aquí.",
  "at.historyExpires": "Los archivos se guardan {days} días.",
  "at.open": "Abrir",
  "at.delete": "Eliminar",
  "at.deleted": "Eliminado",
  "at.status.queued": "En cola",
  "at.status.processing": "Procesando",
  "at.status.done": "Listo",
  "at.status.failed": "Error",

  "at.usage": "{used}/{limit} trabajos hoy",
  "at.usageUnlimited": "Ilimitado",

  "at.err.unsupported_format": "Este formato no es compatible.",
  "at.err.file_too_large": "El archivo es demasiado grande.",
  "at.err.empty_file": "El archivo está vacío.",
  "at.err.daily_limit_reached": "Alcanzaste el límite de hoy. Mejora tu plan para más.",
  "at.err.too_long": "La canción supera la duración permitida.",
  "at.err.processing_failed": "El procesamiento falló. Prueba con otro archivo.",
  "at.err.interrupted": "El trabajo se interrumpió. Inténtalo de nuevo.",
  "at.err.no_change": "Primero cambia el tono o el tempo.",
  "at.err.invalid_params": "Ajustes no válidos.",
  "at.err.analysis_failed": "No pudimos analizar este archivo.",
  "at.err.generic": "Algo salió mal. Inténtalo de nuevo.",
  "at.retry": "Reintentar",

  "at.an.heroTitle": "Encuentra el tono y el BPM de cualquier canción",
  "at.an.heroDesc": "Detecta tempo, tonalidad y código Camelot — perfecto para mezclas DJ, remixes y pitching a playlists.",
  "at.an.start": "Analizar",
  "at.an.analyzing": "Analizando…",
  "at.an.bpm": "Tempo",
  "at.an.key": "Tono",
  "at.an.camelot": "Camelot",
  "at.an.confidence": "Confianza",
  "at.an.halfDouble": "Mitad / doble: {half} · {double}",
  "at.an.alternatives": "Otros tonos posibles",
  "at.an.major": "mayor",
  "at.an.minor": "menor",
  "at.an.tapTempo": "Tap tempo",
  "at.an.tapHint": "Toca al ritmo para comprobar el BPM.",
  "at.an.tap": "Tocar",
  "at.an.reset": "Reiniciar",

  "at.pt.heroTitle": "Cambia tono y tempo",
  "at.pt.heroDesc": "Sube o baja hasta 12 semitonos o acelera / ralentiza la canción sin cambiar el tono. Motor Rubber Band de calidad de estudio.",
  "at.pt.semitones": "Tono (semitonos)",
  "at.pt.tempo": "Tempo",
  "at.pt.formant": "Conservar formantes (voz natural)",
  "at.pt.formantDesc": "Evita que las voces suenen como ardillas al cambiar el tono.",
  "at.pt.preview": "Vista previa",
  "at.pt.previewHint": "Vista previa instantánea en el navegador (tono y tempo enlazados). Renderiza para el resultado de alta calidad.",
  "at.pt.start": "Renderizar",
  "at.pt.result": "Resultado",
  "at.pt.reset": "Restablecer",
  "at.pt.st": "st",
};

export default { en, tr, es };
